import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { SharedModule } from "../../shared/shared.module";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { WorkoutsReducer } from "./store/club-injuries.reducer";
import { WorkoutsEffects } from "./store/club-injuries.effects";
import { Fields } from "./store";
import { InjuryFormComponent } from "../workouts/injury-form/injury-form.component";
import { ClubInjuriesRoutingModule } from "./club-injuries-routing.module";
import { InjuryHistoryComponent } from "../workouts/injury-history/injury-history.component";
import { ClubPlayerInjuriesComponent } from "./club-player-injuries/club-player-injuries.component";
import { ClubInjuriesComponent } from "./club-injuries.component";
import { ClubAllInjuriesComponent } from "./club-injuries-list/club-all-injuries.component";

@NgModule({
  imports: [
    CommonModule,
    ClubInjuriesRoutingModule,

    SharedModule,

    StoreModule.forFeature(Fields.Module, WorkoutsReducer),
    EffectsModule.forFeature([WorkoutsEffects]),
  ],
  declarations: [
    ClubInjuriesComponent,
    ClubAllInjuriesComponent,
    ClubPlayerInjuriesComponent,
    // InjuryFormComponent,
    // InjuryHistoryComponent,
  ],
})
export class ClubInjuriesModule {}



// WEBPACK FOOTER //
// ./src/app/pages/club-injuries/club-injuries.module.ts